import { useInfiniteQuery, useQuery } from '@tanstack/react-query'
import type { UserGetProjectPostsParams, UserGetAgentPostsParams } from '../api'
import { getProjectPostsOptions } from './user-post.options'
import postService from './user-post.service'
import { EUserPostQueryKey } from './user-post.types'

export const useProjectPosts = (params: UserGetProjectPostsParams) => {
  return useQuery(getProjectPostsOptions(params))
}

export const useAgentPosts = (params: UserGetAgentPostsParams) => {
  return useInfiniteQuery({
    queryKey: [EUserPostQueryKey.AGENT_POSTS, params],
    queryFn: ({ pageParam = 0 }) => {
      return postService.getAgentPosts({
        ...params,
        skip: pageParam * (params.limit || 10),
      })
    },
    getNextPageParam: (lastPage, allPages) => {
      const total = lastPage.data?.total || 0
      const currentLength = allPages.reduce(
        (acc, page) => acc + (page.data.posts?.length || 0),
        0,
      )
      return currentLength < total ? allPages.length : undefined
    },
    initialPageParam: 0,
  })
}
